<template>
  <div>
    <div class="position-relative w-100">
      <b-form-input
        readonly
        :value="selectedValue"
        placeholder="Выберите виды работ..."
        class="pointer-cell"
        @click="showModal"
      />
      <div class="select-input-body-wrapper">
        <button type="button" class="custom-btn-select" @click.stop="onIconClick">
          <v-icon v-if="selected.length > 0" name="buttons/cross" :size="11"/>
          <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
        </button>
      </div>
    </div>

    <b-modal
      ref="location_multi_select_modal"
      title="Объекты"
      size="xl"
      modal-class="custom-modal"
      @close="onCancel"
      scrollable
    >
      <div class="page-body">
        <div class="page-filters">
          <div class="d-flex align-items-center">
            <b-input-group>
              <b-form-input size="sm" v-model="query" :placeholder="$t('message.common.search')"/>
              <b-input-group-append>
                <button type="button" class="search-btn" @click.stop="onSearch()">
                  <v-icon name="buttons/search"/>
                </button>
              </b-input-group-append>
            </b-input-group>

            <b-form-select
              id="input-payment-type"
              class="mb-0 mx-2"
              size="sm"
              v-model="paymentType"
              @change="onChangePaymentType"
            >
              <option :value="-1">Все типы оплаты</option>
              <option v-for="option in paymentTypes" :value="option.value">
                {{ option.text }}
              </option>
            </b-form-select>

            <span v-if="showDateButton" :class="['custom-tag cursor-pointer mr-2', isShowDateButtonActive ? 'tag-success' : 'tag-info']" @click.stop="toggleDateFilter">
              <font-awesome-icon :icon="['fas', isShowDateButtonActive ? 'calendar-check' : 'calendar-minus']"/>
              {{ isShowDateButtonActive ? 'Поиск по выбранным датам' : 'Поиск по всем датам' }}
            </span>
          </div>
        </div>

        <template v-if="isBusy || (items && items.length > 0)">
          <div class="page-table-container">
            <b-table
              ref="location_multi_select_table"
              class="custom-table text-small mb-0"
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              @row-clicked="rowClicked"
              :tbody-tr-class="tbodyRowClass"
              no-provider-filtering
              no-provider-paging
              no-provider-sorting
            >
              <template #table-busy>
                <tables-skeleton :fields="fields" :rows="5"/>
              </template>
            </b-table>

            <div class="page-pagination">
              <pagination-footer
                :total-rows="totalRows"
                :per-page.sync="perPage"
                :current-page="currentPage"
                @page-change="(page) => onPagination(null, page)"
                @per-page-change="onPerPageChange"
              />
            </div>
          </div>
        </template>

        <div v-else class="empty-state-container">
          <v-icon name="navbar/empty_table" :size="90"/>
          <h5>{{ isFiltered ? 'Нет данных соответствующих фильтрам.' : 'Нет добавленных исполнителей.' }}</h5>
        </div>
      </div>

      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <p class="float-left">Выбраны: {{ tempSelected.length }}</p>
          <b-button class="custom-btn-primary" @click="onOk">
            Применить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import pageSearchService from "../../utilites/pageSearchService";
  import TablesSkeleton from "../../utilites/commonUi/TablesSkeleton.vue";

export default {
  name: "LocationMultiSelect",
  components: { TablesSkeleton, PaginationFooter },
  mixins: [
    locations,
    pageSearchService
  ],
  props: {
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    showDateButton: { type: Boolean, default: false },
  },
  data() {
    return {
      items: [],
      selected: [],
      tempSelected: [],
      isBusy: false,
      fields: [
        {
          key: 'id',
          class: 'text-center',
        },
        {
          key: 'name',
          label: 'Название'
        },
        {
          key: 'customer_name',
          label: 'Заказчик'
        }
      ],
      query: '',
      paymentType: -1,
      paymentTypes: [
        { value: 0, text: 'Нал' },
        { value: 1, text: 'ООО' },
        { value: 2, text: 'ИП' },
      ],
      isShowDateButtonActive: true,
    }
  },
  computed: {
    selectedValue() {
      if (this.selected.length === 0) {
        return `Все объекты`;
      }
      return `Объекты ${this.selected.length}`;
    },
    isFiltered() {
      return !!this.query && this.query.trim().length > 0;
    },
  },
  watch: {
    'query': {
      handler: async function () {
        if (this.query) {
          await this.getItems();
        }
      }, deep: true
    },
  },
  methods: {
    async configure(locationIds) {
      let locations = [];

      for (const index in locationIds) {
        const id = parseInt(locationIds[index]);
        const location = (await this.getLocationById(id)).data;
        if (location != null) {
          locations.push(location);
        }
      }

      this.selected = locations;
    },
    async showModal() {
      this.tempSelected = [...this.selected];
      this.$refs.location_multi_select_modal.show();
      await this.getItems();
    },
    onClearSelected() {
      this.selected = [];
      this.$emit('onSelect', this.selected);
    },
    onClearQuery() {
      this.query = '';
    },
    onOk() {
      this.selected = [...this.tempSelected];
      this.$emit('onSelect', this.selected);
      this.$refs.location_multi_select_modal.hide();
    },
    onCancel() {
      this.tempSelected = [];
      this.query = '';
    },
    rowClicked(item) {
      // Ищем уже выбранные
      const existItem = this.tempSelected.findIndex(e => e.id === item.id);

      if (existItem !== -1) {
        this.tempSelected.splice(existItem, 1);
        this.$set(item, 'selected', false);
      } else {
        this.tempSelected.push(item);
        this.$set(item, 'selected', true);
      }
    },
    tbodyRowClass(item) {
      return item && item.selected ? ["b-table-row-selected", "table-primary", "pointer-cell"] : ["pointer-cell"];
    },
    async getItems() {
      const data = {
        page: this.currentPage,
        size: this.perPage,
        query: this.query.toLowerCase(),
        payment_type_int: this.paymentType,
        start_date: this.startDate,
        end_date: this.endDate,
      };

      let result;

      if (this.showDateButton && this.isShowDateButtonActive) {
        result = await this.getLocationsSearchByDate(data);
      } else {
        result = await this.getLocationsSearch(data);
      }

      if (!result || !result.data) {
        this.items = [];
        this.totalRows = 0;
        return;
      }

      this.totalRows = result.data.total;
      this.items = result.data.items;
      this.updateSelected();
    },
    updateSelected() {
      if (!this.items) return;

      this.items.forEach((item) => {
        const isSelected = this.tempSelected.some(e => e.id === item.id);
        this.$set(item, 'selected', isSelected);
      });
    },
    async onChangePaymentType() {
      this.currentPage = 1;
      await this.getItems()
    },
    async toggleDateFilter() {
      this.isShowDateButtonActive = !this.isShowDateButtonActive;
      await this.getItems();
    },
    onIconClick() {
      if (this.selected.length) {
        this.onClearSelected();
      } else {
        this.showModal();
      }
    }
  },
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationMultiSelect.vue